import * as React from 'react';
import { useCallback, useMemo, useReducer } from 'react';

import { FIXED_PAGE_NAVIGATION_Z_INDEX } from 'bundles/unified-description-page-common/constants/index';
import StickyPanelContext from 'bundles/unified-description-page-common/contexts/StickyPanelContext';
import type { StickyPanelContextType } from 'bundles/unified-description-page-common/contexts/StickyPanelContext';

export const initialState = { zIndex: FIXED_PAGE_NAVIGATION_Z_INDEX - 1 };

export const ACTION_TYPES = {
  UPDATE_HAS_OPEN_MODAL: 'updateHasOpenModal',
} as const;

type UpdateHasOpenModal = {
  type: typeof ACTION_TYPES.UPDATE_HAS_OPEN_MODAL;
  payload: {
    hasOpenModal?: boolean;
  };
};

type Action = UpdateHasOpenModal;

export function reducer(state: StickyPanelContextType, action: Action) {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_HAS_OPEN_MODAL: {
      const { hasOpenModal } = action.payload;
      return {
        ...state,
        zIndex: hasOpenModal ? FIXED_PAGE_NAVIGATION_Z_INDEX + 1 : FIXED_PAGE_NAVIGATION_Z_INDEX - 1,
      };
    }
    default:
      return state;
  }
}

const StickyPanelProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
  });

  const updateHasOpenModal = useCallback<(...args: $TSFixMe[]) => $TSFixMe>((hasOpenModal) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_HAS_OPEN_MODAL,
      payload: {
        hasOpenModal,
      },
    });
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      updateHasOpenModal,
    }),
    [state, updateHasOpenModal]
  );

  return <StickyPanelContext.Provider value={value}>{children}</StickyPanelContext.Provider>;
};

export default StickyPanelProvider;
